import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SignSaleContract from "./SignSaleContract";
import { formatNumberWithCommas, getDeadlineDate } from "../../AllDateTimeReleventFormate";
import { getSaleRequestById, getSellById } from "../../../../redux/sale/action";
import RoleLabel from "../../RoleLabel";
import ClientUserCommonDetails from "../../ClientUserCommonDetails";
import ContractView from "../../../CustomComponents/ContractView";
import { use } from "apexcharts";

export default function SaleContract() {
  const path = "Assets/scss/FindWork.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const location = useLocation();
  const { state } = location;

  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [pbi, setpbi] = useState(laung ?? "en");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id } = useParams();

  const pbi1 = useSelector(({ sale: { getsalerequestbyid } }) => getsalerequestbyid);

  useEffect(() => {
    dispatch(getSaleRequestById(id));
  }, [id]);


  const getsalebyid = useSelector(({ sale: { getsalebyid } }) => getsalebyid);

  useEffect(() => {
    dispatch(getSellById(id));
  }, [id]);


  useEffect(() => {
    if (state?.approvefrom == "buyer") {
      setpbi(pbi1)
    } if (state?.approvefrom == "seller") {
      setpbi(pbi1)
    } else {
      setpbi(getsalebyid)
    }
  }, [getsalebyid, pbi1]);  

  const formatDateString = (dateString) => {
    const dateObj = new Date(dateString);
    const options = {
      day: "numeric",
      month: "long",
      year: "numeric",
    };
    return dateObj.toLocaleDateString("en-US", options);
  };
  return (
    <div className="container-fluid contract">
      <div className="project-offer project-details col-lg-10 mx-auto">
        <p className="breadcrumbs">
          <a onClick={() => navigate(`/${lan}/searchbuyproducts`)}>BSM &gt; </a>
          <a onClick={() => navigate(-1)}>{pbi?.title || "Sale details"} &gt;</a> Contract
        </p>
        <div className="col-lg-10 mx-auto">
          <div className="contract-sec" id="capture-contract-section">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/project/contract-logo.svg`}
              alt=""
            />
            <div className="flex-sec">
              <p>Date : {formatDateString(pbi?.created_on)}</p>
              <p>ID : {pbi?.id}</p>
            </div>
            <div className="website-design">
              <ContractView type={'sale_agreement'} />
            </div>
            <div className="project-details">
              <div className="flex-sec">
                <p>Project Details</p>
              </div>
              <div className="flex-sec flex-sec1">
                <p style={{ fontWeight: "600" }} >Total cost</p>
                <p>$ {formatNumberWithCommas(pbi?.price)}</p>
              </div>
              <div className="flex-sec flex-sec1">
                <p style={{ fontWeight: "600" }} >Product condition</p>
                <p>{pbi?.product_condition == "1" ? "Brand new" : "Used"}</p>
              </div>
              <div className="flex-sec flex-sec1">
                <p style={{ fontWeight: "600" }} >Shipping charges</p>
                <p>{pbi?.shipping == "1" ? "Included" : "Not Included"}</p>
              </div>
              <div className="flex-sec flex-sec1">
                <p style={{ fontWeight: "600" }} >Quantity</p>
                <p>1 Piece</p>
              </div>
            </div>
            <ClientUserCommonDetails pbi={pbi} />
            <SignSaleContract pbi={pbi} />
          </div>
        </div>
      </div>
    </div>
  );
}
